import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, Link } from "react-router-dom";
import axios from "axios";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import AboutTT from "./pages/AboutTT";

import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import Pricing from "./pages/Pricing";
import APIDocs from "./pages/APIDocs";
import "./App.css";
import Navbar from "./components/Navbar";
import "./styles/navbar.css";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import "./styles/Kontakt.css";
import "./styles/Impressum.css";

function App() {
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [productId, setProductId] = useState("");
  const [ingredients, setIngredients] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!authToken) {
      localStorage.removeItem("authToken");
    }
  }, [authToken]);

  const fetchIngredients = async () => {
    if (!productId) {
      setError("Bitte geben Sie eine Produkt-ID ein.");
      setIngredients([]);
      return;
    }

    setLoading(true);
    setError(null);
    setIngredients([]);

    try {
      const response = await axios.get(
        `https://meine-fastapi-api-b6fyhsg2dcejcab9.westeurope-01.azurewebsites.net/product/${productId}/ingredients`
      );

      if (response.status === 200 && Array.isArray(response.data)) {
        setIngredients(response.data);
      } else {
        setError("Keine Zutaten für diese Produkt-ID gefunden.");
      }
    } catch (err) {
      setError("Fehler beim Abrufen der Daten. Bitte versuchen Sie es später erneut.");
    } finally {
      setLoading(false);
    }
  };

return (
  <Router>
    <header className="app-header">
      <h1>DatenFox</h1>
    </header>
    <Navbar />
    <div className="max-w-screen-xl mx-auto px-6 lg:px-16 pt-20">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/api-docs" element={<APIDocs />} />
        <Route path="/Kontakt" element={<Kontakt />} />
        <Route path="/Impressum" element={<Impressum />} />
		<Route path="/AboutUs" element={<AboutUs />} />
		<Route path="/AboutTT" element={<AboutTT />} />

        <Route path="/login" element={<Login setAuthToken={setAuthToken} />} />
        <Route path="/dashboard" element={authToken ? <Dashboard authToken={authToken} /> : <Navigate to="/login" />} />
      </Routes>
    </div>
  </Router>
);

}

export default App;
